<template>
    <app-wrapper>
        <app-header></app-header>
        <app-body :bodyClass="bodyClass">
            <slot />
        </app-body>
        <lazy-app-footer v-if="showFooter"></lazy-app-footer>
    </app-wrapper>
</template>

<script setup>
const route = useRoute();

const bodyClass = computed(() => {
    if (
        [
            'login',
            'login-code',
            'login-index-passcode',
            'messages',
            'messages-index-idThread',
            'messages-index-idThread-token',
        ].includes(route.name)
    )
        return 'h-screen';
    return 'mb-auto';
});

const showFooter = computed(() => {
    return ![
        'login',
        'login-code',
        'login-index-passcode',
        'messages',
        'messages-index-idThread',
        'messages-index-idThread-token',
    ].includes(route.name);
});
</script>
